<div class="form-errors" *ngIf="field != undefined && field.touched && errors.length">
    <small class="form-errors__message" *ngFor="let error of errors">{{ error }}</small>
</div>
